import { useMemo } from 'react';
import { FormField } from '@src/components/SmartDataTable/types';
import { SUPPLIER_STATUS_OPTIONS } from '../constants';
import { getPhoneFieldConfig } from '@src/utils/phoneUtils';

export const useSuppliersFormFields = (): FormField[] => {
  // Convert readonly options to mutable array
  const statusOptions = SUPPLIER_STATUS_OPTIONS.map(opt => ({
    label: opt.label,
    value: opt.value,
  }));

  return useMemo(
    () => [
      // Row 1
      {
        name: 'name',
        label: 'Agency Name',
        type: 'text',
        required: true,
        placeholder: 'Enter supplier name',
        rules: [
          { required: true, message: 'Please enter supplier name' },
          { max: 30, message: 'Name cannot exceed 30 characters' },
        ],
        layout: { span: 12 },
      },
      {
        name: 'phone',
        label: 'Phone',
        ...getPhoneFieldConfig(true, '98765 43210'),
        props: {
          ...getPhoneFieldConfig().props,
          size: 'middle',
          className: 'compact-phone-field',
        },
        rules: [{ required: true, message: 'Please enter phone number' }],
        layout: { span: 12 },
        tooltip: 'Enter 10-digit mobile number (without country code)',
      },
      // Row 2
      {
        name: 'email',
        label: 'Email',
        type: 'email',
        required: true,
        placeholder: 'Enter email address',
        rules: [
          { required: true, message: 'Please enter email address' },
          { type: 'email', message: 'Please enter a valid email address' },
          { max: 30, message: 'Email cannot exceed 30 characters' },
        ],
        layout: { span: 12 },
      },
      {
        name: 'status',
        label: 'Status',
        type: 'select',
        required: true,
        options: statusOptions,
        placeholder: 'Select status',
        rules: [{ required: true, message: 'Please select status' }],
        layout: { span: 12 },
      },
      // Row 3
      {
        name: 'gst_number',
        label: 'GST Number',
        type: 'text',
        required: false,
        placeholder: 'Enter GST number (optional)',
        rules: [
          { max: 20, message: 'GST number cannot exceed 20 characters' },
          {
            pattern:
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            message: 'Please enter a valid GST number',
          },
        ],
        layout: { span: 24 },
      },
      // Row 4
      {
        name: 'address',
        label: 'Address',
        type: 'textarea',
        required: true,
        placeholder: 'Enter complete address',
        rules: [
          { required: true, message: 'Please enter address' },
          { max: 200, message: 'Address cannot exceed 200 characters' },
        ],
        layout: { span: 24 },
        fieldProps: {
          rows: 3,
          showCount: true,
          maxLength: 200,
        },
      },
    ],
    [statusOptions]
  );
};
